// document.addEventListener("DOMContentLoaded", function() {
//     let slideIndex = 1;
//     let slides = document.getElementsByClassName("mySlides");
//     let dots = document.getElementsByClassName("dot");
//     let textContents = document.getElementsByClassName("text-content");
//     let autoSlideTimeout;
//     let autoSlideEnabled = true; // 自動スライドを制御する新しい変数

//     function showSlides(n) {
//         if (n > slides.length) {slideIndex = 1}
//         if (n < 1) {slideIndex = slides.length}
//         for (let i = 0; i < slides.length; i++) {
//             slides[i].style.display = "none";  
//         }
//         for (let i = 0; i < textContents.length; i++) {
//             textContents[i].style.display = "none";
//         }
//         for (let i = 0; i < dots.length; i++) {
//             dots[i].className = dots[i].className.replace(" active", "");
//         }
//         slides[slideIndex-1].style.display = "block";  
//         textContents[slideIndex-1].style.display = "block";
//         dots[slideIndex-1].className += " active";

//         // 自動スライドのリセットと再開
//         clearTimeout(autoSlideTimeout);
//         if (autoSlideEnabled) {
//             autoSlideTimeout = setTimeout(function() { showSlides(slideIndex += 1); }, 3200);
//         }
//     }

//     function plusSlides(n) {
//         autoSlideEnabled = false; // アローボタンがクリックされたら自動スライドを停止
//         showSlides(slideIndex += n);
//     }

//     function currentSlide(n) {
//         autoSlideEnabled = false; // ページネーションがクリックされたら自動スライドを停止
//         showSlides(slideIndex = n);
//     }

//     document.querySelector(".prev").addEventListener("click", function() {
//         plusSlides(-1);
//     });
//     document.querySelector(".next").addEventListener("click", function() {
//         plusSlides(1);
//     });

//     for (let i = 0; i < dots.length; i++) {
//         dots[i].addEventListener("click", function() { currentSlide(i + 1); });
//     }

//     // スライドショーを開始
//     showSlides(slideIndex);
// });



document.addEventListener("DOMContentLoaded", function() {
    let slideIndex = 1;
    let slides = document.getElementsByClassName("mySlides");
    let dots = document.getElementsByClassName("dot");
    let textContents = document.getElementsByClassName("text-content");
    let autoSlideTimeout;
    let autoSlideEnabled = true; // 自動スライドを制御する新しい変数
    let totalSlides = window.innerWidth < 1024 ? 5 : 4; // 初期値を設定

    function showSlides(n) {
        if (n > totalSlides) {slideIndex = 1}
        if (n < 1) {slideIndex = totalSlides}
        for (let i = 0; i < slides.length; i++) {
            slides[i].style.display = "none";  
        }
        for (let i = 0; i < textContents.length; i++) {
            textContents[i].style.display = "none";
        }
        for (let i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" active", "");
        }
        slides[slideIndex-1].style.display = "block";  
        textContents[slideIndex-1].style.display = "block";
        if (dots[slideIndex-1]) {
            dots[slideIndex-1].className += " active";
        }

        // 自動スライドのリセットと再開
        clearTimeout(autoSlideTimeout);
        if (autoSlideEnabled) {
            autoSlideTimeout = setTimeout(function() { showSlides(slideIndex += 1); }, 3200);
        }
    }

    function plusSlides(n) {
        autoSlideEnabled = false; // アローボタンがクリックされたら自動スライドを停止
        showSlides(slideIndex += n);
    }

    function currentSlide(n) {
        autoSlideEnabled = false; // ページネーションがクリックされたら自動スライドを停止
        showSlides(slideIndex = n);
    }

    function detectDevice() {
        totalSlides = window.innerWidth < 1024 ? 5 : 4;
        if (totalSlides === 5) {
            document.querySelectorAll('.mobile-only-slide').forEach(slide => slide.style.display = "block");
            document.querySelectorAll('.mobile-pagination').forEach(pagination => pagination.style.display = "none");
            document.querySelectorAll('.pc-pagination').forEach(pagination => pagination.style.display = "none");
        } else {
            document.querySelectorAll('.mobile-only-slide').forEach(slide => slide.style.display = "none");
            document.querySelectorAll('.mobile-pagination').forEach(pagination => pagination.style.display = "none");
            document.querySelectorAll('.pc-pagination').forEach(pagination => pagination.style.display = "block");
        }
    }

    document.querySelector(".prev").addEventListener("click", function() {
        plusSlides(-1);
    });
    document.querySelector(".next").addEventListener("click", function() {
        plusSlides(1);
    });

    for (let i = 0; i < dots.length; i++) {
        dots[i].addEventListener("click", function() { currentSlide(i + 1); });
    }

    // デバイスの種類を検出し、スライド数を設定
    detectDevice();

    // スライドショーを開始
    showSlides(slideIndex);

    // ウィンドウサイズが変更されたときにデバイスを再検出
    window.onresize = function() {
        detectDevice();
        showSlides(slideIndex);
    };
});

